import { Flex, HStack, Image, Tag, Text, VStack } from '@chakra-ui/react';
import { PortalIcon } from 'features/common/components/PortalIcon';
import TruncatedText from 'features/common/components/TruncatedText';
import { tenantsFallbackIcon } from 'features/common/utils/icons';
import { isInteger } from 'lodash';

interface IDestinationCardProps {
  appName: string;
  tenantName: string;
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  color?: string;
  image?: string;
  appLogo?: string;
  'data-testid'?: string;
  ['data-behavior-analytics-id']?: string;
  customerEnvironmentType?: string;
  active?: boolean;
  selected?: boolean;
  sites?: number;
}

export const DestinationCard = ({
  appName,
  tenantName,
  onClick,
  onMouseEnter,
  onMouseLeave,
  color = 'neutral',
  'data-testid': dataTestId,
  'data-behavior-analytics-id': dataBehaviorAnalyticsId,
  customerEnvironmentType,
  image,
  appLogo,
  selected,
  sites,
}: IDestinationCardProps) => {
  return (
    <Flex
      background='white'
      borderWidth='1px'
      borderStyle='solid'
      borderColor={selected ? 'purple.500' : 'transparent'}
      boxShadow={selected ? 'lg' : 'base'}
      gap='3'
      p='4'
      w='436px'
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      cursor='pointer'
      _hover={{ backgroundColor: 'gray.100' }}
      data-behavior-analytics-id={dataBehaviorAnalyticsId}
      data-testid={dataTestId}
      data-appname={tenantName}
      borderRadius='md'
      transitionProperty='common'
      transitionDuration='normal'
    >
      {image ? (
        <Image alignSelf='center' boxSize='8' src={image} />
      ) : (
        <PortalIcon
          alignSelf='center'
          data-testid='destination-tile-default-icon'
          boxSize='8'
          m='2'
          path={appLogo || tenantsFallbackIcon}
          color={`${color}.600`}
        />
      )}

      <VStack
        spacing='0'
        flexGrow='1'
        alignItems='flex-start'
        justifyContent='space-between'
      >
        <Text
          fontWeight='medium'
          textAlign='left'
          w='full'
          noOfLines={1}
          wordBreak='break-all'
        >
          {appName}
        </Text>

        <HStack gap='10'>
          <TruncatedText text={tenantName} />
          {customerEnvironmentType && (
            <Tag colorScheme='neutral' size='sm' minW='min-content'>
              {customerEnvironmentType?.toLowerCase()}
            </Tag>
          )}
        </HStack>
      </VStack>

      <VStack
        spacing='0'
        flexGrow='1'
        alignItems='flex-end'
        justifyContent='end'
      >
        {/* <Tag
          colorScheme={active ? 'green' : 'neutral'}
          size='sm'
          fontWeight='semibold'
          textTransform='uppercase'
          visibility={'hidden'}
        >
          {active ? 'Active' : 'Inactive'}
        </Tag> */}

        {selected && isInteger(sites) && (
          <Text
            textAlign='right'
            color='chakra-subtle-text'
            w='full'
            noOfLines={1}
            wordBreak='break-all'
          >
            {sites} site{sites && sites > 1 ? 's' : ''}
          </Text>
        )}
      </VStack>
    </Flex>
  );
};
